import { ImageMetadata } from 'modules/movableInk/types';
import { CreatedImageMetadata } from 'modules/movableInk/types';

export const isCreatedBlock = (
  imageMetadata: Partial<ImageMetadata>,
): imageMetadata is CreatedImageMetadata =>
  'campaignId' in imageMetadata && 'created' in imageMetadata;
